import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

interface MetaProps {
  name: string;
}

const Meta: React.FC<MetaProps> = ({ name }) => {
  return (
    <Helmet>
      <title>{name}</title>
    </Helmet>
  );
};

// Define PropTypes with .isRequired for compatibility
Meta.propTypes = {
  name: PropTypes.string.isRequired,
};

export default Meta;
